import { AxiosError } from "axios";
import { useCallback } from "react";

type BackendError = { message?: string };

// 401s are handled globally by the axios response interceptor (it clears the session and
// redirects to /login). This hook just surfaces the remaining errors (400/403/404/network)
// to the component so the user sees a reason. The handler is memoized so it stays stable
// across renders — callers use it as an effect/useCallback dependency, and an unstable
// identity there caused a re-fetch loop (skeleton flicker) on the profile pages.
export const useHandleCatchError = () => {
  const handleError = useCallback(
    (error: unknown, setErrorMessage: (message: string) => void) => {
      const axiosError = error as AxiosError<BackendError>;
      if (axiosError.response) {
        if (axiosError.response.status === 401) {
          return; // handled by the interceptor
        }
        setErrorMessage(
          `${axiosError.response.status} ${
            axiosError.response.data?.message ?? ""
          }`.trim()
        );
      } else {
        setErrorMessage(
          `${axiosError.code ?? ""} ${axiosError.message ?? ""}`.trim()
        );
      }
    },
    []
  );
  return handleError;
};
